import React, { useState } from 'react';

import { useAnalytics } from '@r-client/shared/data/analytics';
import { Button, IButtonProps, Link, Text } from '@r-client/shared/ui/core';
import { Dropdown } from '@r-client/shared/ui/dropdown';
import { Calendar, SvgIconLight } from '@r-client/shared/ui/icons';
import { BasicMenu, BasicMenuItem } from '@r-client/shared/ui/menu';

import { getCalendarsCollection, TCalendarEvent } from '../../../utils';
import { CalendarIcon } from '../calendar-icon';

export interface IMenuButtonProps extends IButtonProps {
  event: TCalendarEvent;
}

export const MenuButton: React.FC<
  React.PropsWithChildren<IMenuButtonProps>
> = ({ event, ...restProps }) => {
  const analytics = useAnalytics();
  const [visible, setVisible] = useState(false);
  const closeDropdown = (calendarName: string) => {
    analytics.track({
      name: 'event_calendar_button_clicked',
      params: { calendar_name: calendarName },
    });
    setVisible(false);
  };
  return (
    <Dropdown
      arrow
      trigger="hover"
      visible={visible}
      onVisibleChange={setVisible}
      content={
        <BasicMenu>
          {getCalendarsCollection(event).map((calendar) => {
            return (
              <BasicMenuItem
                key={calendar.type}
                onClick={() => closeDropdown(calendar.displayName)}
              >
                <Link
                  target="_blank"
                  rel="nofollow noopener"
                  variant={Link.variants.unstyled}
                  href={calendar.url}
                >
                  <div>
                    <Text as="span" m="0 1brm 0 0" color="blue">
                      <CalendarIcon type={calendar.type} />
                    </Text>
                    {calendar.displayName}
                  </div>
                </Link>
              </BasicMenuItem>
            );
          })}
        </BasicMenu>
      }
    >
      <Button {...restProps}>
        <SvgIconLight icon={Calendar} />
      </Button>
    </Dropdown>
  );
};
